<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<div class="container">
    @for (box of charBoxes(); track $index) {
        <div
            #charBox
            class="char-box"
            [class.active]="currentIndex() === $index"
            [class.filled]="box.filled"
            [attr.tabindex]="0"
            (click)="setActiveBox($index)"
            (focus)="setActiveBox($index)"
            (keydown)="setActiveBox($index)">
            {{ box.value }}
        </div>
    }
</div>
